<p>cps-action-bar works!</p>
